<ng-container *ngIf="!!view; else allAdvice">
  <app-advice-day></app-advice-day>
</ng-container>

<ng-template #allAdvice>
  <bz-all-advice></bz-all-advice>
</ng-template>

<div class="static-footer">
  <bz-static-footer [setAbsoluteProperty]="false"></bz-static-footer>
</div>
